<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId">
    <ng-container *ngIf="fundSummaryInfo">
      <ft-summary-international
        *ngIf="showIntlSummary && !isLitPreview"
        [brConfig]="brConfig"
        [fundSummaryInfo]="fundSummaryInfo"
        [calcTypeVisibility]="calcTypeVisibility"
        [showRatings]="showRatings"
      ></ft-summary-international>
      <ft-summary-us
        *ngIf="!showIntlSummary && !isLitPreview"
        [brConfig]="brConfig"
        [fundSummaryInfo]="fundSummaryInfo"
        [calcTypeVisibility]="calcTypeVisibility"
        [showRatings]="showRatings"
      ></ft-summary-us>
    </ng-container>
    <div edsRow>
      <div edsCol>
        <ft-fund-header-alerts
          [fundId]="brConfig.fundId"
          [shareClassCode]="brConfig.shareClassCode"
        ></ft-fund-header-alerts>
      </div>
    </div>
  </ng-container>
</ng-container>
